/**
 * Czech (CS) translations
 */

export const cs = {
    // Common
    common: {
        save: 'Uložit',
        cancel: 'Zrušit',
        delete: 'Smazat',
        edit: 'Upravit',
        add: 'Přidat',
        search: 'Hledat',
        filter: 'Filtrovat',
        back: 'Zpět',
        loading: 'Načítání...',
        error: 'Chyba',
        success: 'Úspěch',
        confirm: 'Potvrdit',
        yes: 'Ano',
        no: 'Ne',
        close: 'Zavřít',
        submit: 'Odeslat',
        login: 'Přihlásit se',
        logout: 'Odhlásit se',
        register: 'Registrovat se',
        email: 'Email',
        password: 'Heslo',
        name: 'Jméno',
        firstName: 'Jméno',
        lastName: 'Příjmení',
        phone: 'Telefon',
        address: 'Adresa',
        street: 'Ulice',
        houseNumber: 'Č.p.',
        city: 'Město',
        zip: 'PSČ',
        date: 'Datum',
        time: 'Čas',
        status: 'Stav',
        actions: 'Akce',
        details: 'Detail',
        description: 'Popis',
        notes: 'Poznámky',
        or: 'nebo',
        appName: 'ASP Portál',
        saving: 'Ukládám…',
        saveChanges: 'Uložit změny',
        processing: 'Zpracování…',
        operationFailed: 'Operace selhala',
    },

    // Role
    role: {
        customer: 'Zákazník',
        dealer: 'Dealer',
        admin: 'Super správce',
    },

    // Account status
    accountStatus: {
        clean: 'Aktivní',
        pending: 'Čeká na aktivaci',
        disabled: 'Blokován',
        requestDelete: 'Žádost o smazání',
    },

    vehicleStatus: {
        pending: 'Čeká na schválení',
        active: 'Schváleno',
        rejected: 'Zamítnuto',
        infoRequested: 'Vyžádáno doplnění',
    },

    vehicleServiceStatus: {
        ordered: 'Objednáno',
        inProgress: 'Probíhá servis',
        waitingForParts: 'Čeká na díly',
        completed: 'Dokončeno',
        cancelled: 'Zrušeno',
    },

    vehicleTransferStatus: {
        pending: 'Čeká na schválení',
        approved: 'Schváleno',
        rejected: 'Zamítnuto',
        infoRequested: 'Vyžádáno doplnění',
    },

    // Auth — sdílené napříč stránkami
    auth: {
        signOut: 'Odhlásit se',
        accessDenied: {
            title: 'Nemáte oprávnění',
            message: 'Nemáte oprávnění pro přístup k této stránce.',
        },
        backToLogin: 'Zpět na přihlášení',
        googleLoginFailed: 'Přihlášení přes Google se nezdařilo',
        authenticationRequired: 'Uživatel musí být přihlášen',

        // Přihlášení (LoginPage)
        login: {
            title: 'Přihlášení',
            heading: 'Přihlaste se ke svému účtu',
            button: 'Přihlásit se',
            submitting: 'Přihlašuji...',
            withGoogle: 'Přihlásit přes Google',
            invalidCredentials: 'Nesprávný e-mail nebo heslo. Zkuste to znovu.',
            googleFailed: 'Přihlášení přes Google se nezdařilo.',
            noAccount: 'Nemáte účet?',
            registerLink: 'Zaregistrujte se',
            forgotPassword: 'Zapomněli jste heslo?',
            forgotPasswordLink: 'Obnovte si jej',
        },

        // Registrace (RegisterPage)
        register: {
            title: 'Registrace',
            completeTitle: 'Dokončit registraci',
            button: 'Registrovat se',
            failed: 'Registrace se nezdařila',
            confirmPassword: 'Potvrdit heslo',
            chooseMethod: 'Zvolte způsob registrace',
            byEmail: 'Registrace e-mailem',
            byGoogle: 'Registrace přes Google',
            hasAccount: 'Máte již účet?',
            loginLink: 'Přihlásit se',
            checkAndFillDetails: 'Zkontrolujte a doplňte své údaje:',
            emailFromGoogle: 'E-mail je převzat z vašeho Google účtu a nelze ho změnit',
            emailFromAdmin: 'E-mail byl nastaven administrátorem a nelze ho změnit',
            continueWithGoogle: 'Pokračovat přes Google',
            orWithPassword: 'nebo heslem',
            marketingConsent: 'Souhlasím se zasíláním obchodních sdělení a novinek od ASP Group',
            marketingConsentOptional: 'Souhlasím se zasíláním obchodních sdělení a novinek od ASP Group (volitelné)',
            inviteNotFound: 'Pozvánka nebyla nalezena nebo vypršela.',
            inviteUsed: 'Pozvánka již byla použita nebo je neplatná.',
            inviteLoadFailed: 'Nepodařilo se načíst pozvánku.',
        },

        // Obnova hesla (ResetPasswordPage)
        resetPassword: {
            title: 'Obnova hesla',
            description: 'Zadejte svůj e-mail a zašleme vám odkaz pro obnovení hesla.',
            button: 'Odeslat odkaz',
            sending: 'Odesílám…',
            sent: 'E-mail s odkazem pro obnovu hesla byl odeslán na',
            failed: 'Nepodařilo se odeslat e-mail. Zkontrolujte, zda je adresa správná.',
        },

        // Ověření e-mailu (EmailVerificationPage)
        verifyEmail: {
            title: 'Ověřte svůj e-mail',
            description: 'Na adresu {{email}} jsme odeslali ověřovací odkaz. Klikněte na odkaz v e-mailu a poté se vraťte sem.',
            resend: 'Znovu odeslat',
            resendCooldown: 'Znovu odeslat ({{seconds}} s)',
            resendSuccess: 'Ověřovací e-mail byl znovu odeslán.',
            check: 'Jsem ověřen – pokračovat',
            notYet: 'Váš e-mail ještě nebyl ověřen. Zkontrolujte svou schránku.',
            failed: 'Nepodařilo se odeslat ověřovací e-mail.',
        },

        // Blokace účtu (StatusBlockPage)
        statusBlock: {
            clearButton: 'Zrušit označení a pokračovat',
            processing: 'Zpracování…',
            clearFailed: 'Nepodařilo se zrušit stav účtu.',
            fallback: {
                title: 'Váš účet má nastaven omezující stav',
                description: 'Stav účtu: "{{status}}". Pro pokračování zrušte tento stav.',
            },
            requestDelete: {
                title: 'Váš účet je označen k odstranění',
                description: 'Správce systému označil váš účet pro smazání. Pokud si to rozmyslíte a chcete pokračovat v používání aplikace, zrušte toto označení. O zrušení bude automaticky informován administrátor.',
            },
        },
    },

    // Navigation
    nav: {
        dashboard: 'Dashboard',
        profile: 'Profil',
        users: 'Uživatelé',
        settings: 'Nastavení',
        myGarage: 'Moje garáž',
        serviceDesk: 'Servisní pult',
        currentServices: 'Aktuální servisy',
        notifications: 'Notifikace',
        vehicleRegistrations: 'Registrace',
        transfers: 'Převody',
        accounts: 'Účty',
        settingsLists: 'Číselníky',
        exports: 'Exporty',
        auditLog: 'Audit log',
        home: 'Domů',
        about: 'O projektu',
        howItWorks: 'Jak to funguje',
        support: 'Podpora',
        register: 'Registrace',
        goToApp: 'Přejít do aplikace',
        logout: 'Odhlásit',
        login: 'Přihlášení',
        privacySettings: 'Souhlasy a soukromí',
    },

    mainLayout: {
        footerDescription: 'Komplexní řešení pro správu servisní historie, záruk a dokumentace vašich strojů. Vše na jednom místě, dostupné odkudkoliv.',
        footerQuickLinks: 'Rychlé odkazy',
        footerContact: 'Kontakt',
        footerContactEmail: 'info@aspgroup.cz',
        footerContactPhone: '+420 378 21 21 21',
        footerContactHours: 'Po-Pá: 8:00 - 17:00',
        footerCopyright: '© {{year}} AstrumQ Interactive s.r.o.',
    },

    // Users
    user: {
        users: 'Uživatelé',
        userDetails: 'Detail uživatele',
        role: 'Role',
        roleCustomer: 'Zákazník',
        roleDealer: 'Dealer',
        roleAdmin: 'Administrátor',
        createdAt: 'Registrován',
        lastLogin: 'Poslední přihlášení',
        active: 'Aktivní',
        inactive: 'Neaktivní',
        updateRole: 'Změnit roli',
        deactivate: 'Deaktivovat',
        activate: 'Aktivovat',
        userUpdated: 'Uživatel byl aktualizován',
        myProfile: 'Můj profil',
        profilePlaceholder: 'Profil uživatele bude implementován.',
        usersManagement: 'Správa uživatelů',
        usersManagementPlaceholder: 'Správa uživatelů bude implementována.',
    },

    // Dashboard
    dashboard: {
        title: 'Dashboard',
        welcome: 'Vítejte zpět',
        statistics: 'Statistiky',
        newOrders: 'Nové zakázky',
        ordersInProgress: 'Zakázky v řešení',
        completedOrders: 'Dokončené zakázky',
        totalRevenue: 'Celkové tržby',
        recentOrders: 'Poslední zakázky',
        pendingOrders: 'Čekající zakázky',
        todayOrders: 'Dnešní zakázky',
        totalOrders: 'Celkem objednávek',
    },

    // Notifications
    notification: {
        welcomeTitle: 'Vítejte v ASP Servisní Centrum',
        welcomeMessage: 'Děkujeme za registraci. Nyní můžete začít používat naše služby.',
        orderStatusChangeTitle: 'Změna stavu objednávky',
        orderStatusChangeMessage: 'Stav vaší objednávky #{orderId} byl změněn.',
    },

    // Email
    email: {
        orderConfirmationSubject: 'Potvrzení objednávky #{orderId}',
        orderConfirmationTitle: 'Potvrzení servisní objednávky',
        orderConfirmationGreeting: 'Dobrý den {customerName},',
        orderConfirmationMessage: 'Vaše servisní objednávka byla úspěšně vytvořena.',
        orderConfirmationDetails: 'Detail objednávky:',
        orderConfirmationOrderNumber: 'Číslo objednávky:',
        orderConfirmationDevice: 'Zařízení:',
        orderConfirmationDeviceType: 'Typ:',
        orderConfirmationFollowUp: 'O dalším postupu vás budeme informovat emailem.',
        orderConfirmationSignature: 'S pozdravem,<br>Tým ASP Servisní Centrum',

        orderStatusUpdateSubject: 'Aktualizace objednávky #{orderId}',
        orderStatusUpdateTitle: 'Aktualizace stavu objednávky',
        orderStatusUpdateGreeting: 'Dobrý den {customerName},',
        orderStatusUpdateMessage: 'Informujeme vás o změně stavu vaší servisní objednávky <strong>#{orderId}</strong>.',
        orderStatusUpdateNewStatus: 'Nový stav:',
        orderStatusUpdateNote: 'Poznámka:',
        orderStatusUpdateSignature: 'S pozdravem,<br>Tým ASP Servisní Centrum',

        orderStatusInProgress: 'Vaše objednávka je právě v řešení.',
        orderStatusWaitingForParts: 'Čekáme na náhradní díly pro opravu.',
        orderStatusCompleted: 'Servis je dokončen a zařízení je připraveno k vyzvednutí.',
        orderStatusCancelled: 'Objednávka byla zrušena.',
        orderStatusDefault: 'Stav vaší objednávky se změnil.',

        dailyReportSubject: 'Denní přehled ASP Servisní Centrum',
        dailyReportTitle: 'Denní přehled',
        dailyReportGreeting: 'Dobrý den,',
        dailyReportMessage: 'Následuje denní přehled servisního centra:',
        dailyReportStatistics: 'Statistiky:',
        dailyReportNewOrders: 'Nové objednávky dnes:',
        dailyReportPendingOrders: 'Čekající objednávky:',
        dailyReportOrdersInProgress: 'Objednávky v řešení:',
        dailyReportSignature: 'S pozdravem,<br>Systém ASP Servisní Centrum',
    },

    // Profil (Profile)
    profile: {
        title: 'Můj profil',
        subtitle: 'Správa osobních údajů a zabezpečení účtu.',
        personal: {
            title: 'Osobní údaje',
            emailHelp: 'Pro změnu e-mailu kontaktujte podporu.',
            savedSuccess: 'Osobní údaje byly úspěšně uloženy.',
            saveFailed: 'Nepodařilo se uložit osobní údaje.',
        },
        garage: {
            title: 'Údaje garáže',
            savedSuccess: 'Adresa garáže byla úspěšně uložena.',
            saveFailed: 'Nepodařilo se uložit adresu garáže.',
        },
        password: {
            title: 'Změna hesla',
            subtitle: 'Pro zvýšení bezpečnosti doporučujeme používat silné heslo.',
            currentPassword: 'Současné heslo',
            newPassword: 'Nové heslo',
            confirmNewPassword: 'Potvrzení nového hesla',
            changing: 'Měním heslo…',
            changeButton: 'Změnit heslo',
            mismatch: 'Nová hesla se neshodují.',
            tooShort: 'Nové heslo musí mít alespoň 6 znaků.',
            changedSuccess: 'Heslo bylo úspěšně změněno.',
            wrongCurrent: 'Současné heslo je nesprávné.',
            changeFailed: 'Nepodařilo se změnit heslo.',
        },
    },

    // Notifikace (Notifications)
    notifications: {
        title: 'Notifikace',
        subtitle: 'Centrum oznámení a upozornění.',
        markAllRead: 'Označit vše jako přečtené',
        filterUnread: 'Nepřečtené',
        filterAll: 'Všechny',

        // Obsah notifikací — ukládá se jako klíč, frontend překládá přes t()
        vehicleStatus: {
            newRegistration: {
                title: 'Nová registrace vozidla',
                message: 'Vozidlo bylo přidáno k registraci a čeká na schválení.',
            },
            pending: {
                title: 'Vozidlo čeká na schválení',
                message: 'Vozidlo bylo vráceno do stavu „Čeká na schválení".',
            },
            active: {
                title: 'Stav vozidla: Schváleno',
                message: 'Stav vozidla byl změněn na: Schváleno.',
            },
            rejected: {
                title: 'Stav vozidla: Zamítnuto',
                message: 'Stav vozidla byl změněn na: Zamítnuto.',
            },
            infoRequested: {
                title: 'Stav vozidla: Vyžádáno doplnění',
                message: 'Stav vozidla byl změněn na: Vyžádáno doplnění.',
            },
        },

        serviceStatus: {
            newRecord: {
                title: 'Nový servisní záznam',
                message: 'Byl přidán nový servisní záznam k vozidlu.',
            },
            newOrder: {
                title: 'Nová servisní objednávka',
                message: 'Byla vytvořena nová servisní objednávka pro vozidlo.',
            },
            ordered: {
                title: 'Změna stavu servisu',
                message: 'Stav servisní objednávky byl změněn na: Objednáno.',
            },
            inProgress: {
                title: 'Změna stavu servisu',
                message: 'Stav servisní objednávky byl změněn na: Probíhá servis.',
            },
            waitingForParts: {
                title: 'Změna stavu servisu',
                message: 'Stav servisní objednávky byl změněn na: Čeká na díly.',
            },
            completed: {
                title: 'Změna stavu servisu',
                message: 'Stav servisní objednávky byl změněn na: Dokončeno.',
            },
            cancelled: {
                title: 'Změna stavu servisu',
                message: 'Stav servisní objednávky byl změněn na: Zrušeno.',
            },
        },

        vehicleTransfer: {
            new: {
                title: 'Nová žádost o převod stroje',
                message: 'Byla podána nová žádost o převod stroje.',
            },
            requestedFromYou: {
                title: 'Žádost o převod vašeho stroje',
                message: 'Byl podán požadavek na převod stroje.',
            },
            requestedToYou: {
                title: 'Probíhá převod stroje na vás',
                message: 'Byl zahájen převod stroje na váš účet.',
            },
            pending: {
                title: 'Žádost o převod čeká na schválení',
                message: 'Žádost o převod stroje čeká na schválení administrátorem.',
            },
            approved: {
                title: 'Převod stroje byl schválen',
                message: 'Žádost o převod stroje byla schválena.',
            },
            rejected: {
                title: 'Převod stroje byl zamítnut',
                message: 'Žádost o převod stroje byla zamítnuta.',
            },
            infoRequested: {
                title: 'Převod stroje — vyžádáno doplnění',
                message: 'K žádosti o převod stroje bylo vyžádáno doplnění informací.',
            },
        },

        system: {
            welcome: {
                title: 'Vítejte v ASP Servisní Centrum',
                message: 'Děkujeme za registraci. Nyní můžete začít používat naše služby.',
            },
            statusCleared: {
                title: 'Zrušení stavu účtu',
                message: 'Uživatel {{userName}} ({{email}}) zrušil stav "{{previousStatus}}" na svém účtu.',
            },
        },
    },

    // Souhlasy a soukromí (PrivacySettings)
    privacySettings: {
        title: 'Souhlasy a soukromí',
        subtitle: 'Správa vašich osobních údajů a marketingových preferencí.',
        marketing: {
            title: 'Marketingové souhlasy',
            description: 'Nastavte si, jaké informace od nás chcete dostávat.',
            switchLabel: 'Chci dostávat novinky a speciální nabídky',
            switchDescription: 'Zasílání informací o nových modelech, příslušenství a akčních nabídkách ASP Group. Souhlas můžete kdykoliv odvolat.',
            saved: 'Uloženo',
            saveButton: 'Uložit nastavení',
        },
        gdpr: {
            title: 'Ochrana osobních údajů (GDPR)',
            text1: 'Vaše osobní údaje zpracováváme v souladu s Nařízením Evropského parlamentu a Rady (EU) 2016/679 (GDPR).',
            text2: 'Správcem vašich osobních údajů je společnost ASP Group s.r.o. Údaje zpracováváme za účelem vedení elektronické servisní knížky, plnění záručních podmínek a poskytování servisních služeb.',
            text3: 'Máte právo na přístup k vašim údajům, jejich opravu, výmaz ("právo být zapomenut"), omezení zpracování, přenositelnost údajů a vznesení námitky.',
            policyLink: 'Zobrazit plné znění Zásad ochrany osobních údajů →',
        },
        dangerZone: {
            title: 'Nebezpečná zóna',
            deleteTitle: 'Smazání účtu',
            deleteDescription: 'Jakmile svůj účet smažete, ztratíte přístup do portálu. Historie servisních záznamů k vašim strojům (vázaná na VIN) zůstane v systému zachována pro potřeby záruky a servisu, ale vaše osobní údaje budou anonymizovány.',
            deleteButton: 'Požádat o smazání účtu',
            requestFailed: 'Nepodařilo se nastavit žádost o smazání.',
        },
        deleteDialog: {
            title: 'Smazat účet',
            warning: 'Opravdu chcete smazat svůj účet? Tato akce je nevratná. Vaše osobní údaje budou anonymizovány, ale historie strojů zůstane zachována.',
            reasonLabel: 'Důvod odchodu (nepovinné)',
            confirmButton: 'Smazat účet',
        },
    },

    // Landing page
    landing: {
        hero: {
            badge: 'Nový portál pro správu strojů.',
            badgeLink: 'Zjistit více →',
            title: 'Elektronická servisní kniha pro vaše stroje',
            subtitle: 'Mějte přehled o historii servisu, zárukách a stavu vašich strojů. Vše na jednom místě, dostupné kdykoliv a odkudkoliv.',
            registerCta: 'Zaregistrovat se',
            howItWorks: 'Jak to funguje',
        },
        features: {
            overline: 'Rychleji a efektivněji',
            title: 'Vše, co potřebujete pro správu flotily',
            description: 'Náš portál zjednodušuje komunikaci mezi majiteli strojů, dealery a servisem.',
            warranty: {
                title: 'Záruky pod kontrolou',
                desc: 'Automatické sledování záručních lhůt a upozornění na blížící se konec záruky.',
            },
            serviceHistory: {
                title: 'Servisní historie',
                desc: 'Kompletní přehled všech servisních úkonů, výměn dílů a garančních prohlídek.',
            },
            documentation: {
                title: 'Digitální dokumentace',
                desc: 'Manuály, technické průkazy a servisní knížky vždy po ruce v digitální podobě.',
            },
        },
    },

    // Moje garáž (Garage)
    garage: {
        title: 'Moje garáž',
        subtitle: 'Přehled vašich registrovaných strojů.',
        addMachine: 'Přidat stroj',
        searchPlaceholder: 'Vyhledat stroj...',
        empty: {
            title: 'Žádné stroje',
            description: 'Nebyly nalezeny žádné stroje odpovídající vašemu hledání.',
        },
        warrantyUntil: 'Záruka do:',
        availableForSale: 'Volné k prodeji',
        statusNote: {
            rejected: 'Důvod zamítnutí:',
            infoRequested: 'Vyžádáno doplnění:',
        },
        transfer: {
            active: 'Aktivní převod',
            statusLabel: 'Stav:',
            direction: 'Směr:',
            outgoing: 'Odchozí',
            incoming: 'Příchozí',
            createdAt: 'Vytvořen:',
            chip: 'Převod',
            vehicleTitle: 'Převáděné vozidlo',
        },
        viewDetail: 'Zobrazit detail',
        menu: {
            odometer: 'Zadat aktuální km/mth',
            viewDetail: 'Zobrazit detail',
            orderService: 'Podklady pro servis',
        },
    },

    // Přidat stroj (AddMachine)
    addMachine: {
        breadcrumb: 'Přidat stroj',
        title: 'Přidat nový stroj',
        steps: {
            identification: 'Identifikace',
            purchaseDetails: 'Detaily nákupu',
            documentation: 'Dokumentace',
            review: 'Kontrola',
        },
        vin: {
            label: 'VIN kód stroje',
            placeholder: 'Zadejte 17-místný VIN kód',
            hint: 'VIN kód naleznete na rámu stroje nebo v technickém průkazu.',
            verify: 'Ověřit a pokračovat',
            verifying: 'Ověřování...',
            errorVerify: 'Při ověřování VIN kódu došlo k chybě. Zkuste to prosím znovu.',
        },
        identifiedModel: 'Identifikovaný model',
        purchaseDate: 'Datum nákupu',
        purchaseDateHint: 'Nejdříve od 1. 6. 2026 (datum spuštění aplikace).',
        purchaseDateTooEarly: 'Datum nákupu nemůže být dřívější než 1. 6. 2026.',
        dealer: 'Prodejce (Dealer)',
        extendedWarranty: {
            label: 'Mám zájem o 5letou záruku – ',
            conditionsLink: 'podmínky prodloužené záruky',
            lockedTooltip: 'Prodlouženou záruku lze sjednat pouze do 30 dnů od data nákupu.',
        },
        back: 'Zpět',
        continue: 'Pokračovat',
        submitting: 'Odesílání...',
        upload: {
            button: 'Nahrát soubor',
            dragHint: 'nebo přetáhněte sem',
            sizeHint: 'PDF, JPG, PNG do 10MB',
            selectedFile: 'Vybrán soubor: {{name}}',
        },
        transferMode: {
            docLabel: 'Doklad o převodu vlastnictví',
            docHint: 'Nahrajte doklad prokazující převod vlastnictví stroje (povinné).',
            reviewTitle: 'Rekapitulace žádosti o převod',
            reviewVinLabel: 'VIN kód',
            reviewTypeLabel: 'Typ žádosti',
            reviewTypeValue: 'Převod stroje',
            reviewDocLabel: 'Doklad o převodu',
            submitButton: 'Odeslat žádost o převod',
            errorSubmit: 'Při odesílání žádosti o převod došlo k chybě. Zkuste to prosím znovu.',
        },
        normalMode: {
            docLabel: 'Nahrát fakturu / Kupní smlouvu',
            docHint: 'Pro ověření záruky je nutné nahrát doklad o koupi.',
            reviewTitle: 'Rekapitulace údajů',
            reviewVinLabel: 'VIN kód',
            reviewModelLabel: 'Model',
            reviewDateLabel: 'Datum nákupu',
            reviewDealerLabel: 'Prodejce',
            reviewDocLabel: 'Dokumentace',
            submitButton: 'Odeslat ke schválení',
            errorSubmit: 'Při registraci stroje došlo k chybě. Zkuste to prosím znovu.',
        },
        transferDialog: {
            title: 'Stroj je již registrován',
            body1Prefix: 'Stroj s VIN kódem',
            body1Suffix: 'je již registrován v systému.',
            body2: 'Chcete požádat o převod tohoto stroje na vaši garáž? Budete muset nahrát doklad o převodu vlastnictví.',
            cancelButton: 'Ne, zpět',
            confirmButton: 'Ano, požádat o převod',
        },
    },

    // Detail vozidla (VehicleDetail)
    vehicleDetail: {
        breadcrumbGarage: 'Moje garáž',
        orderService: 'Podklady pro servis',
        submitForApproval: 'Předat ke schválení',
        notFound: 'Stroj s VIN kódem „{{vin}}" nebyl nalezen.',
        tabs: {
            overview: 'Přehled',
            serviceHistory: 'Servisní historie',
            transfers: 'Převody',
            documents: 'Dokumenty',
        },
        overview: {
            rejectionReason: 'Důvod zamítnutí',
            infoRequested: 'Vyžádáno doplnění',
            warrantyStatus: 'Stav záruky',
            warrantyNotFilled: 'Záruka nevyplněna',
            warrantyActive: 'Záruka je aktivní',
            warrantyExpired: 'Záruka vypršela',
            warrantyType: 'Typ záruky',
            warrantyValidUntil: 'Platnost do',
            lastService: 'Poslední servis',
            noService: 'Žádný servis zatím evidován.',
            dateLabel: 'Datum',
            kmLabel: 'Stav km',
            mthLabel: 'Stav mth',
            orderNext: 'Objednat další',
        },
        sidebar: {
            vinLabel: 'Číslo vozidla (VIN)',
            kmLabel: 'Najetých km',
            mthLabel: 'Najetých mth',
            chartTitle: 'Vývoj km / mth',
            chartKm: 'Stav km',
            chartMth: 'Moto-hodiny',
            actionsTitle: 'Ostatní akce',
            enterOdometer: 'Zadat aktuální km / mth',
            uploadImage: 'Nahrát obrázek vozidla',
            setNickname: 'Nastavit přezdívku',
            availableForSaleLabel: 'Volné k prodeji',
            availableForSaleHint: 'Pokud vozidlo označíte jako volné k prodeji, příští přepis vlastnictví (registrace nového majitele) proběhne automaticky, bez čekání na schválení administrátorem.',
            availableForSaleError: 'Při ukládání příznaku došlo k chybě. Zkuste to prosím znovu.',
        },
        nicknameDialog: {
            title: 'Přezdívka vozidla',
            description: 'Přezdívka slouží jako váš osobní rozlišovací název vozidla. Zobrazuje se v přehledu garáže i na detailu vozidla — vidíte ji pouze vy.',
            label: 'Přezdívka',
            placeholder: 'např. Traktor na louku',
        },
        serviceHistory: {
            empty: 'Žádné záznamy o servisu.',
        },
        transferHistory: {
            fromOwner: 'Původní majitel',
            toOwner: 'Nový majitel',
        },
        documents: {
            vehicleDocuments: 'Dokumenty vozidla',
            serviceGroupLabel: 'Servis — {{type}}, {{date}}',
            transferGroupLabel: 'Převod — {{date}}',
        },
    },

    // Podklady pro servis (ServiceRequest)
    serviceRequest: {
        title: 'Podklady pro servis',
        intro: 'Popište problém a přidejte foto, video nebo hlasovou zprávu ještě před příjezdem do servisu — pomůže nám to rychleji identifikovat závadu a připravit potřebné díly předem.',
        vinLabel: 'VIN kód stroje',
        dealerLabel: 'Vyberte servisní středisko',
        serviceTypeLabel: 'Typ servisu',
        kmLabel: 'Aktuální stav km',
        mthLabel: 'Aktuální stav motohodin',
        description: 'Popis problému',
        descriptionPlaceholder: 'Popište závadu nebo požadované úkony co nejpřesněji...',
        attachments: 'Foto, video nebo hlasová zpráva (nepovinné)',
        uploadFiles: 'Nahrát soubory',
        dragHint: 'nebo přetáhněte sem',
        sizeHint: 'Foto, video, zvuk nebo PDF do 20 MB',
        submitting: 'Odesílám...',
        submit: 'Odeslat podklady',
        error: 'Nepodařilo se odeslat podklady. Zkuste to prosím znovu.',
        success: {
            title: 'Podklady odeslány',
            description: 'Vaše podklady byly úspěšně odeslány vybranému servisnímu středisku. Dealer si je projde a ozve se vám s návrhem termínu.',
            backButton: 'Zpět do garáže',
        },
    },

    // Detail servisu (ServiceDetail)
    serviceDetail: {
        title: 'Detail servisu',
        notFound: 'Servisní záznam nebyl nalezen.',
        infoTitle: 'Informace o servisu',
        serviceTypeLabel: 'Typ servisu',
        recordDate: 'Datum záznamu',
        preferredDate: 'Preferované datum',
        machineStatusTitle: 'Stav stroje při servisu',
        kmLabel: 'Stav km',
        mthLabel: 'Moto-hodiny',
        vinLabel: 'Stroj (VIN)',
        descriptionTitle: 'Popis',
        noDescription: 'Žádný popis.',
        documentsTitle: 'Dokumenty',
        completedTitle: 'Zpracování servisu',
        plannedFinish: 'Plánované dokončení',
        completedAt: 'Dokončeno',
        tasksTitle: 'Provedené servisní úkony',
        noTasks: 'Žádné servisní úkony.',
    },

    // Detail převodu — zákazník (TransferDetail)
    transferDetail: {
        title: 'Detail převodu',
        notFound: 'Žádost o převod nebyla nalezena.',
        submitForApproval: 'Předat ke schválení',
        machineTitle: 'Stroj',
        fromOwnerTitle: 'Původní majitel',
        toOwnerTitle: 'Nový majitel',
        nameLabel: 'Jméno',
        requestTitle: 'Žádost',
        requestDate: 'Datum žádosti',
        documentsLabel: 'Doklady',
        rejectedAlert: 'Žádost byla zamítnuta:',
        infoRequestedAlert: 'Vyžádáno doplnění:',
        infoRequestedAlertNoNote: 'Vyžádáno doplnění informací.',
    },

    // Dealer — Detail garáže zákazníka (GarageDetail)
    garageDetail: {
        notFound: 'Zákazník nebyl nalezen.',
        customerTitle: 'Zákazník',
        nameLabel: 'Jméno',
        phoneLabel: 'Telefon',
        emailLabel: 'E-mail',
        garageAddressLabel: 'Adresa garáže',
        vehiclesTab: 'Vozidla ({{count}})',
        servicesTab: 'Servisní záznamy ({{count}})',
        noVehicles: 'Zákazník nemá žádná vozidla.',
        noServices: 'Žádné servisní záznamy.',
        warrantyValid: 'Záruka platná',
        warrantyExpired: 'Záruka vypršela',
        viewDetail: 'Detail →',
        machineLink: 'Stroj →',
    },

    // Dealer — Servisní pult (ServiceDesk)
    serviceDesk: {
        title: 'Servisní pult',
        subtitle: 'Vyhledejte stroj nebo zákazníka pro správu servisu.',
        vinTab: 'Hledat podle VIN',
        customerTab: 'Hledat zákazníka',
        vinLabel: 'VIN kód stroje',
        vinPlaceholder: 'Zadejte celý nebo část VIN stroje',
        vinSearching: 'Hledám...',
        vinSearch: 'Vyhledat stroj',
        vinNotFound: 'Žádný stroj začínající na "{{vin}}" nebyl nalezen.',
        vinError: 'Při hledání stroje došlo k chybě. Zkuste to prosím znovu.',
        nameLabel: 'Jméno a příjmení',
        namePlaceholder: 'Jan Novák',
        emailPlaceholder: 'jan.novak@example.com',
        garageAddressLabel: 'Adresa garáže',
        garageAddressPlaceholder: 'Ulice, PSČ nebo město',
        customerSearching: 'Hledám...',
        customerSearch: 'Vyhledat zákazníka',
        noCustomers: 'Žádný zákazník nebyl nalezen.',
        viewDetail: 'Detail →',
        foundMachines_one: 'Nalezeno {{count}} stroj',
        foundMachines_few: 'Nalezeno {{count}} stroje',
        foundMachines_other: 'Nalezeno {{count}} strojů',
        foundCustomers_one: 'Nalezeno {{count}} zákazník',
        foundCustomers_few: 'Nalezeno {{count}} zákazníci',
        foundCustomers_other: 'Nalezeno {{count}} zákazníků',
    },

    // Dealer — Fronta servisů (ServiceQueue)
    serviceQueue: {
        title: 'Fronta servisů',
        subtitle: 'Přehled strojů, které jsou momentálně v servisu.',
        missingDealerId: 'Váš účet zatím není přiřazen k žádnému servisnímu středisku, proto zde nejsou vidět žádné záznamy. Obraťte se prosím na administrátora.',
        newIntake: 'Nový příjem',
        searchPlaceholder: 'Hledat VIN, zákazníka...',
        filterAll: 'Všechny',
        colMachine: 'Stroj',
        colCustomer: 'Zákazník',
        colServiceType: 'Typ servisu',
        colDates: 'Termíny',
        colStatus: 'Stav',
        received: 'Přijato:',
        plannedFinish: 'Plán. dokončení:',
        empty: 'Žádné servisy.',
    },

    // Dealer — Detail servisu (ServiceDetail)
    dealerServiceDetail: {
        notFound: 'Servisní záznam nebyl nalezen.',
        title: 'Detail servisu',
        customerLabel: 'Zákazník:',
        infoTitle: 'Informace o servisu',
        machineTitle: 'Stroj',
        serviceTypeLabel: 'Typ servisu',
        receivedDate: 'Datum přijetí',
        preferredDate: 'Preferované datum',
        plannedFinishLabel: 'Plán. dokončení',
        modelLabel: 'Model',
        kmLabel: 'Stav km',
        mthLabel: 'Moto-hodiny',
        vinLabel: 'VIN',
        descriptionTitle: 'Popis',
        noDescription: 'Žádný popis.',
        documentsTitle: 'Dokumenty',
        processingTitle: 'Zpracování servisu',
        plannedFinishEditable: 'Plánované dokončení',
        completedLabel: 'Dokončeno',
        tasksTitle: 'Provedené servisní úkony',
        noTasks: 'Zatím žádné úkony.',
        addTaskPlaceholder: 'Přidat úkon...',
        saveError: 'Nepodařilo se uložit změny.',
        saveDateError: 'Vyplňte prosím plánované datum dokončení.',
        saveSuccess: 'Změny byly uloženy.',
        saving: 'Ukládám...',
        save: 'Uložit',
    },

    // Dealer — Přidat servisní záznam (AddServiceRecord)
    addServiceRecord: {
        title: 'Zapsat servisní záznam – {{model}}',
        serviceTypeLabel: 'Typ servisu',
        dateLabel: 'Datum servisu',
        kmLabel: 'Nájezd (km)',
        mthLabel: 'Nájezd (mth)',
        kmError: 'Musí být ≥ {{min}} km',
        mthError: 'Musí být ≥ {{min}} mth',
        descriptionLabel: 'Popis práce',
        descriptionPlaceholder: 'Detailní popis provedených úkonů...',
        photosTitle: 'Dokumentace',
        uploadButton: 'Nahrát soubor',
        uploadHint: 'Fotky, PDF a další dokumenty do 10MB',
        missingDealerId: 'Váš účet zatím není přiřazen k žádnému servisnímu středisku. Obraťte se prosím na administrátora, bez toho nelze servisní záznam uložit.',
        cancel: 'Zrušit',
        submit: 'Uložit záznam',
        error: 'Záznam se nepodařilo uložit. Zkuste to prosím znovu.',
    },

    // Dealer — Detail převodu (TransferDetail)
    dealerTransferDetail: {
        notFound: 'Žádost o převod nebyla nalezena.',
        title: 'Detail převodu',
        machineTitle: 'Stroj',
        vinLabel: 'VIN',
        machineTypeLabel: 'Typ stroje',
        fromOwnerTitle: 'Původní majitel',
        toOwnerTitle: 'Nový majitel',
        nameLabel: 'Jméno',
        emailLabel: 'Email',
        phoneLabel: 'Telefon',
        requestTitle: 'Žádost',
        requestDate: 'Datum žádosti',
        rejectionLabel: 'Důvod zamítnutí',
        infoRequestedLabel: 'Vyžádáno doplnění',
        documentsLabel: 'Doklady',
    },

    // Dealer — Detail stroje (VehicleDetail)
    dealerVehicleDetail: {
        notFound: 'Stroj s VIN kódem „{{vin}}" nebyl nalezen.',
        detailTitle: 'Detail stroje',
        modelLabel: 'Model',
        warrantyLabel: 'Záruka',
        warrantyValid: 'Platná',
        warrantyExpired: 'Vypršela',
        warrantyValidUntil: ' do {{date}}',
        lastServiceLabel: 'Poslední servis',
        odometerLabel: 'Nájezd',
        tabServiceHistory: 'Historie servisu',
        tabTransfers: 'Převody',
        tabDocuments: 'Dokumenty',
        addService: 'Zapsat servis',
        noServices: 'Zatím žádné záznamy o servisu.',
        missingDealerId: 'Váš účet zatím není přiřazen k žádnému servisnímu středisku, proto zde nelze zobrazit servisní záznamy. Obraťte se prosím na administrátora.',
        vehicleDocuments: 'Dokumenty vozidla',
        serviceGroupLabel: 'Servis — {{type}}, {{date}}',
        transferGroupLabel: 'Převod — {{date}}',
    },

    // Dealer — Historie převodů stroje (VehicleDetail/TransferHistory)
    dealerTransferHistory: {
        fromOwner: 'Původní majitel',
        toOwner: 'Nový majitel',
    },

    // Shared components
    notificationList: {
        empty: 'Žádné notifikace.',
        markUnread: 'Označit jako nepřečtené',
        markRead: 'Označit jako přečtené',
        delete: 'Smazat notifikaci',
        showAll: 'Zobrazit všechny notifikace',
    },

    documentList: {
        uploadButton: 'Vložit dokument',
        empty: 'Žádné dokumenty.',
        uploadError: 'Při nahrávání dokumentu došlo k chybě. Zkuste to prosím znovu.',
        deleteConfirm: 'Opravdu smazat soubor „{{name}}"?',
        deleteError: 'Při mazání souboru došlo k chybě. Zkuste to prosím znovu.',
    },

    odometerModal: {
        title: 'Zadat aktuální km / mth',
        kmLabel: 'Stav km',
        mthLabel: 'Přidat motohodiny',
        kmPlaceholder: 'napr. 1250',
        kmInfo: 'Kilometry – zadejte aktuální stav budíku (absolutní hodnota).',
        mthInfo: 'Motohodiny – zadejte počet hodin přidaných od posledního záznamu (přičtou se k celkovému součtu).',
    },

    vehiclePictureUpload: {
        title: 'Nahrát obrázek vozidla',
        selectButton: 'Vybrat obrázek',
        previewAlt: 'Náhled',
        uploading: 'Nahrávám...',
        upload: 'Nahrát',
        notImageError: 'Vybraný soubor není obrázek.',
        uploadError: 'Nahrávání selhalo. Zkuste to prosím znovu.',
    },

    notFound: {
        title: 'Stránka nenalezena',
        description: 'Omlouváme se, ale stránka, kterou hledáte, neexistuje nebo byla přesunuta.',
        backHome: 'Zpět na hlavní stránku',
    },

    placeholderPage: {
        underConstruction: 'Tato stránka je ve výstavbě.',
    },

    // Admin — Dashboard
    adminDashboard: {
        title: 'Admin dashboard',
        systemOverview: 'Přehled systému',
        pendingRegistrations: 'Čekající registrace',
        pendingTransfers: 'Čekající převody',
        activeUsers: 'Aktivní uživatelé',
        newIncidents: 'Nové incidenty',
        viewDetail: 'Zobrazit detail',
    },

    // Admin — Správa účtů (AccountsList)
    accountsList: {
        title: 'Správa účtů',
        subtitle: 'Přehled všech uživatelů, dealerů a administrátorů v systému.',
        newAccount: 'Nový účet',
        searchPlaceholder: 'Hledat jméno nebo e-mail...',
        filterAll: 'Vše',
        colUser: 'Uživatel',
        colRole: 'Role',
        colStatus: 'Stav',
        colCreated: 'Vytvořeno',
        colLastLogin: 'Poslední přihlášení',
        authNotCreated: 'Nezaložen',
        noUsers: 'Žádní uživatelé neodpovídají filtru.',
        pagination: '{{from}}–{{to}} z {{count}}',
    },

    // Admin — Detail účtu (AccountDetail)
    accountDetail: {
        notFound: 'Účet nebyl nalezen.',
        backToList: 'Zpět na seznam',
        title: 'Detail účtu: {{name}}',
        resetPassword: 'Reset hesla',
        resetPasswordSent: 'E-mail pro reset hesla byl odeslán na {{email}}.',
        resetPasswordFailed: 'Nepodařilo se odeslat e-mail pro reset hesla.',
        deleteAccount: 'Smazat účet',
        cancelDeletion: 'Zrušit smazání',
        block: 'Zablokovat',
        activate: 'Aktivovat',
        sectionTitle: 'Osobní údaje',
        nameLabel: 'Jméno',
        emailLabel: 'E-mail',
        phoneLabel: 'Telefon',
        roleLabel: 'Role',
        dealerLabel: 'Servisní středisko',
        accountStatusLabel: 'Stav účtu',
        authNotCreated: 'Nezaložen',
        authBlocked: 'Blokován',
        authActive: 'Aktivní',
        pendingActivation: 'Čeká na aktivaci',
        requestDelete: 'Žádost o smazání',
        statusSetAt: 'Stav nastaven',
        createdAt: 'Vytvořeno',
        lastLogin: 'Poslední přihlášení',
        emailVerifiedLabel: 'E-mail ověřen',
        emailVerifiedYes: 'Ano',
        emailVerifiedNo: 'Ne',
    },

    // Admin — Vytvořit účet (CreateAccount)
    createAccount: {
        title: 'Vytvořit nový účet',
        accountTypeLabel: 'Typ účtu',
        roleDealer: 'Dealer',
        roleAdmin: 'Administrátor',
        roleCustomer: 'Zákazník (manuálně)',
        roleInfoAdmin: 'Administrátor bude mít plný přístup k systému. Doporučujeme nastavit 2FA.',
        roleInfoDealer: 'Dealer bude mít přístup k servisnímu pultu.',
        roleInfoCustomer: 'Zákazník bude mít přístup ke správě svých strojů.',
        emailHelperText: 'Na tuto adresu bude odeslána pozvánka k dokončení registrace.',
        dealerLabel: 'Servisní středisko (Dealer)',
        cancel: 'Zrušit',
        creating: 'Vytváření...',
        createAndSend: 'Vytvořit a odeslat pozvánku',
        error: 'Nepodařilo se vytvořit pozvánku. Zkuste to znovu.',
        successTitle: 'Pozvánka byla vytvořena',
        successDescription: 'Pozvánka pro {{name}} ({{email}}) byla úspěšně vytvořena. Platnost pozvánky je 7 dní.',
        emailNotAvailableAlert: 'Automatické odesílání e-mailů bude brzy k dispozici. Prozatím zkopírujte odkaz níže a odešlete ho uživateli ručně.',
        copiedLabel: 'Odkaz byl zkopírován!',
        copyLinkTooltip: 'Kopírovat odkaz',
        backToList: 'Zpět na seznam',
        createAnother: 'Vytvořit další',
    },

    // Admin — Registrace vozidel (VehicleRegistrationQueue)
    vehicleRegistrationQueue: {
        title: 'Registrace vozidel',
        subtitle: 'Seznam vozidel čekajících na schválení registrace.',
        filterPending: 'Čekající',
        filterAll: 'Vše',
        colMachine: 'Stroj / VIN',
        colDealer: 'Prodejce',
        colDate: 'Datum registrace',
        colStatus: 'Stav',
        empty: 'Žádná vozidla k zobrazení.',
    },

    // Admin — Detail registrace vozidla (VehicleRegistrationDetail)
    vehicleRegistrationDetail: {
        notFound: 'Registrace nenalezena.',
        backToList: 'Zpět na seznam',
        title: 'Detail registrace',
        requestInfo: 'Vyžádat doplnění',
        reject: 'Zamítnout',
        approve: 'Schválit',
        sectionTitle: 'Informace o stroji a zákazníkovi',
        sectionSubtitle: 'Zkontrolujte údaje oproti přiloženým dokladům.',
        rejectionReason: 'Důvod zamítnutí:',
        infoRequested: 'Vyžádáno doplnění:',
        vinLabel: 'VIN kód',
        modelLabel: 'Model stroje',
        purchaseDateLabel: 'Datum nákupu',
        extendedWarrantyRequestLabel: 'Žádost o prodlouženou záruku',
        warrantyTypeLabel: 'Typ záruky',
        warrantyUntilLabel: 'Záruka do',
        dealerLabel: 'Prodejce (Dealer)',
        customerLabel: 'Zákazník',
        documentsLabel: 'Doklady',
        warrantyStandard: 'Standardní záruka',
        warrantyExtended: 'Prodloužená záruka',
        rejectDialogTitle: 'Zamítnout registraci',
        rejectDialogText: 'Uveďte prosím důvod zamítnutí. Tento důvod bude odeslán zákazníkovi e-mailem.',
        rejectReasonLabel: 'Důvod zamítnutí',
        rejectReasonPlaceholder: 'Důvod zamítnutí...',
        rejectButton: 'Zamítnout',
        infoDialogTitle: 'Vyžádat doplnění informací',
        infoDialogText: 'Napište zákazníkovi, co je potřeba doplnit nebo opravit (např. nečitelná faktura).',
        infoMessageLabel: 'Zpráva pro zákazníka',
        infoMessagePlaceholder: 'Zpráva pro zákazníka...',
        infoSendButton: 'Odeslat žádost',
    },

    // Admin — Fronta převodů (TransferQueue)
    transferQueue: {
        title: 'Fronta převodů',
        subtitle: 'Seznam žádostí o převod stroje na nového majitele.',
        filterPending: 'Čekající',
        filterAll: 'Všechny',
        colMachine: 'Stroj',
        colFromOwner: 'Původní majitel',
        colToOwner: 'Nový majitel',
        colStatus: 'Stav',
        requesterChip: 'Žadatel',
        empty: 'Žádné žádosti o převod k zobrazení.',
    },

    // Admin — Detail převodu (TransferDetail)
    adminTransferDetail: {
        notFound: 'Žádost o převod nebyla nalezena.',
        title: 'Detail převodu',
        requestInfo: 'Vyžádat doplnění',
        reject: 'Zamítnout',
        approve: 'Schválit',
        machineTitle: 'Stroj',
        vinLabel: 'VIN',
        machineTypeLabel: 'Typ stroje',
        warrantyTypeLabel: 'Typ záruky',
        warrantyUntilLabel: 'Záruka do',
        warrantySelectPlaceholder: 'Vyberte typ',
        warrantyStandard: 'Standardní záruka',
        warrantyExtended: 'Prodloužená záruka',
        warrantyOriginal: '(původně: {{value}})',
        fromOwnerTitle: 'Původní majitel',
        toOwnerTitle: 'Nový majitel',
        nameLabel: 'Jméno',
        emailLabel: 'Email',
        phoneLabel: 'Telefon',
        requestTitle: 'Žádost',
        requestDate: 'Datum žádosti',
        rejectionLabel: 'Důvod zamítnutí',
        infoRequestedLabel: 'Vyžádáno doplnění',
        documentsLabel: 'Doklady',
        approveDialogTitle: 'Potvrdit schválení převodu',
        approveDialogBody: 'Schvalujete převod vozidla {{model}} ({{vin}}).',
        approveDialogNewOwner: 'Nový majitel:',
        approveDialogWarrantyType: 'Typ záruky:',
        approveDialogWarrantyUntil: 'Záruka do:',
        approveDialogConfirm: 'Chcete pokračovat?',
        approveConfirmButton: 'Potvrdit a schválit',
        rejectDialogTitle: 'Zamítnout převod',
        rejectDialogText: 'Uveďte prosím důvod zamítnutí.',
        rejectReasonLabel: 'Důvod zamítnutí',
        rejectReasonPlaceholder: 'Důvod zamítnutí...',
        rejectButton: 'Zamítnout',
        infoDialogTitle: 'Vyžádat doplnění informací',
        infoDialogText: 'Napište, co je potřeba doplnit.',
        infoMessageLabel: 'Zpráva',
        infoMessagePlaceholder: 'Zpráva...',
        infoSendButton: 'Odeslat žádost',
    },

    // Admin — Číselníky (SettingListsItems)
    settingLists: {
        title: 'Číselníky',
        subtitle: 'Správa systémových číselníků pro registrace a servisní záznamy.',
        dealersTab: 'Seznam dealerů',
        serviceTypesTab: 'Typy servisů',
        addItem: 'Přidat položku',
        colLabel: 'Označení',
        colDescription: 'Popis',
        colStatus: 'Stav',
        colActions: 'Akce',
        labelPlaceholder: 'Označení',
        descriptionPlaceholder: 'Popis (nepovinné)',
        statusActive: 'Aktivní',
        statusBlocked: 'Blokován',
    },

    // Audit Log
    auditLog: {
        title: 'Audit log',
        subtitle: 'Přehled veškerých operací v systému',
        filterDateFrom: 'Datum od',
        filterDateTo: 'Datum do',
        filterEntityType: 'Typ entity',
        filterEntityId: 'ID entity',
        filterActorUid: 'Actor UID',
        filterAll: 'Vše',
        filterApply: 'Filtrovat',
        filterReset: 'Reset',
        colTimestamp: 'Čas',
        colActor: 'Actor',
        colOperation: 'Operace',
        colEntityType: 'Typ entity',
        colEntityId: 'ID entity',
        colAction: 'Akce',
        empty: 'Žádné záznamy',
        loadMore: 'Načíst další',
        loadingMore: 'Načítám…',
        before: 'Před změnou',
        after: 'Po změně',
        metadata: 'Metadata',
        noDetail: 'Žádné další informace',
    },

    // Errors
    errors: {
        generic: 'Něco se pokazilo',
        networkError: 'Chyba sítě',
        unauthorized: 'Neautorizovaný přístup',
        forbidden: 'Zakázaný přístup',
        notFound: 'Nenalezeno',
        serverError: 'Chyba serveru',
        validationError: 'Chyba validace',
        requiredField: 'Toto pole je povinné',
        invalidEmail: 'Neplatný email',
        invalidPhone: 'Neplatné telefonní číslo',
        passwordTooShort: 'Heslo je příliš krátké',
        passwordsDoNotMatch: 'Hesla se neshodují',
    },
};
